import React from 'react'
import { Link } from 'gatsby'

const HomeChecklistSectionNew = ({ title, subTitle, description }) => (
  <div className="bg-gray-100 w-full py-16">
    <div className="w-11/12 max-w-3xl mx-auto">
      <h2 className='text-4xl md:text-5xl text-site-lightblue text-center font-bold mb-8'>{title ? title : "Section Title"}</h2>
      <h3 className='text-2xl md:text-3xl text-blue-900 text-center font-bold mb-8 italic'>{subTitle ? subTitle : "Section Subtitle"}</h3>
      <p className='text-lg text-gray-800 text-center max-w-lg mx-auto'>{description ? description : "Section description here..."}</p>
      <div className='flex justify-center'>
        <Link to="/quote">
          <button className="bg-red-600 hover:bg-red-700 text-white font-display px-8 py-4 text-xl text-center font-semibold tracking-wide rounded mt-8 shadow-lg">
            Get a Quote
          </button>
        </Link>
      </div>
    </div>
  </div>
)

export default HomeChecklistSectionNew